import cx from "classnames";
import type { ReactElement } from "react";
import { useEffect, useState } from "react";

type Props = Readonly<{
  isEnabled?: boolean;
  onChange?: (isEnabled: boolean) => void;
}>;

export default function ToggleSwitch({
  isEnabled = false,
  onChange,
}: Props): ReactElement {
  const [isActive, setIsActive] = useState(isEnabled);

  useEffect(() => {
    setIsActive(isEnabled);
  }, [isEnabled]);

  const handleToggle = () => {
    const newIsActive = !isActive;
    setIsActive(newIsActive);
    if (onChange) {
      onChange(newIsActive);
    }
  };

  return (
    <button
      id="toggle-switch"
      className={cx(
        "relative p-[2px] rounded-full w-[50px] h-inherit transition-all duration-300 ease-in-out",
        {
          "bg-primary": isActive,
          "bg-inverse-secondary": !isActive,
        },
      )}
      onClick={handleToggle}
      data-testid="toggle-switch"
      aria-label="toggle-switch"
      tabIndex={0}
    >
      <div
        className={cx(
          "w-6 h-6 rounded-full bg-secondary transition-transform duration-300 ease-in-out",
          {
            "transform translate-x-[90%]": isActive,
            "transform translate-x-0": !isActive,
          },
        )}
      />
    </button>
  );
}
